import { render, staticRenderFns } from "./NewDSimpleRadioPreview.vue?vue&type=template&id=24af635a&"
import script from "./NewDSimpleRadioPreview.vue?vue&type=script&lang=js&"
export * from "./NewDSimpleRadioPreview.vue?vue&type=script&lang=js&"
import style0 from "./NewDSimpleRadioPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports